/* eslint id-length: "off" */
import PropTypes from "prop-types";
import MDMusicArtwork from "@/components/music/md-player/MDMusicArtwork";
import MDMusicControls from "@/components/music/md-player/MDMusicControls";
import MDMusicExternalLink from "@/components/music/md-player/MDMusicExternalLink";
import MDMusicTrackInfo from "@/components/music/md-player/MDMusicTrackInfo";

const MDMusicSingle = ({controlProps, track}) => (
  <div className="mdmusic mdmusic-single">
    <div className="mdmusic-single-art">
      <MDMusicArtwork size="compact" track={track}/>
    </div>
    <div className="mdmusic-single-body">
      <MDMusicExternalLink className="mdmusic-single-link" track={track}/>
      <MDMusicTrackInfo size="compact" track={track} withLink={false}/>
      <MDMusicControls {...controlProps}/>
    </div>
  </div>
);

MDMusicSingle.propTypes = {
  controlProps: PropTypes.object.isRequired,
  track: PropTypes.object.isRequired,
};

export default MDMusicSingle;
